export default "__VITE_ASSET__BwfA_59L__"